import React from "react"

/**
 * Type guard function to determine if a React node is a React element.
 *
 * @param {React.ReactNode} child The React node to check.
 * @returns {child is React.ReactElement} True if the provided React node is a React element; otherwise, false.
 *
 * This utility function leverages `React.isValidElement` to check if a given React node
 * is a React element. It can be used to safely assert that a React node is indeed a React element
 * before attempting to access properties specific to React elements, such as `props` or `type`.
 *
 * Example usage:
 *
 * const element = <div>Hello World</div>;
 * const isElement = isReactElement(element);
 * // Returns true
 */
export const isReactElement = (child: React.ReactNode): child is React.ReactElement => {
    return React.isValidElement(child)
}
